const imp = () => import(/* webpackChunkName: "loadSprite_knowledge_color"*/  "../sprite/loadSprite_knowledge_color");
const loadMap_knowledge_color: { [key: string]: () => Promise<any> } = {
  "Icon-AUDIO": imp,
  "Icon-HTML": imp,
  "Icon-IMAGE": imp,
  "Icon-Knowledge-document04": imp,
  "Icon-Knowledge-document01": imp,
  "Icon-Knowledge-document05": imp,
  "Icon-OTHER": imp,
  "Icon-PDF": imp,
  "Icon-TXT": imp,
  "Icon-OFFICE": imp,
  "Icon-VIDEO": imp,
  "Icon-Knowledge-document02": imp,
  "Icon-Knowledge-document03": imp,
}
export default loadMap_knowledge_color;